import { Typography, makeStyles, Grid } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { Icon } from "../../../../components/base";

const useStyles = makeStyles(() => ({
  label: {
    textTransform: "uppercase",
    color: COLORS.darks[0][100],
  },
}));

export const IconLabelDescription = ({ iconSrc, label, children }) => {
  const classes = useStyles();

  return (
    <Grid container wrap="nowrap" spacing={1}>
      <Grid item>
        <Icon src={iconSrc} color={COLORS.davisGrey} />
      </Grid>
      <Grid container item direction="column">
        <Grid item>
          <Typography variant="h3" className={classes.label}>
            {label}
          </Typography>
        </Grid>
        <Grid item>{children}</Grid>
      </Grid>
    </Grid>
  );
};
